export const hourRule = {
  start: 6,
  end: 23
}

export const openingHours = [...Array((hourRule.end + 1)- hourRule.start).keys()].map( i => i + hourRule.start );

export const validatePriceDetail = (priceDetail: PriceDetail) =>
  priceDetail.start_time >= hourRule.start &&
  priceDetail.end_time <= hourRule.end &&
  priceDetail.start_time < priceDetail.end_time &&
  priceDetail.price > 0

export const validateHourRuleSetting = (hr: HourRule) =>
  hr.start_time >= hourRule.start &&
  hr.end_time <= hourRule.end

export const  validateCourt = (c: Court) =>
  c.venue_id || c.venue_price_name